import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
})
export class PaymentsComponent implements OnInit {

  constructor(    private authService: AuthService) { }

  ngOnInit() {
  }
  
  getModuleGroupAndModuleAccess(moduleName: string, groupName: string) {
    return this.authService.getModuleGroupAndModuleAccess(moduleName, groupName);
}

}
